import React from 'react';
import { Sparkles, ImageIcon, Package, AlertCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import Modal from '../common/Modal';

const AIConsentModal = ({ onConsent, onClose }) => {
  const { t } = useTranslation();

  const disclosures = [
    {
      icon: <Sparkles className="w-5 h-5 text-purple-500" />,
      title: t('aiConsent.howItWorks.title'),
      description: t('aiConsent.howItWorks.description')
    },
    {
      icon: <ImageIcon className="w-5 h-5 text-purple-500" />,
      title: t('aiConsent.whatWeSend.title'),
      description: t('aiConsent.whatWeSend.description')
    },
    {
      icon: <Package className="w-5 h-5 text-purple-500" />,
      title: t('aiConsent.storage.title'),
      description: t('aiConsent.storage.description')
    },
    {
      icon: <AlertCircle className="w-5 h-5 text-purple-500" />,
      title: t('aiConsent.safety.title'),
      description: t('aiConsent.safety.description')
    }
  ];

  const handleConsent = () => {
    localStorage.setItem('hasConsentedToAI', 'true');
    onConsent();
  };

  return (
    <Modal
      onClose={onClose}
      labelledBy="ai-consent-title"
      centered
      panelClassName="shadow-2xl max-h-[90vh] overflow-hidden"
    >
        {/* Header */}
        <div className="p-6 text-center border-b border-gray-100">
          <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-gradient-to-br from-purple-100 to-pink-100 flex items-center justify-center">
            <Sparkles className="w-8 h-8 text-purple-500" />
          </div>
          <h2 id="ai-consent-title" className="text-xl font-bold text-gray-900">
            {t('aiConsent.title')}
          </h2>
          <p className="text-sm text-gray-500 mt-1">
            {t('aiConsent.subtitle')}
          </p>
        </div>

        {/* Content */}
        <div className="p-6 space-y-4 max-h-64 overflow-y-auto">
          {disclosures.map((item, index) => (
            <div key={index} className="flex gap-3">
              <div className="flex-shrink-0 mt-0.5">{item.icon}</div>
              <div>
                <h3 className="text-sm font-semibold text-gray-900">{item.title}</h3>
                <p className="text-xs text-gray-500 mt-0.5">{item.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Links */}
        <div className="px-6 py-3 border-t border-gray-100 flex justify-center gap-6">
          <a
            href="https://mymanifest.app/privacy"
            target="_blank"
            rel="noopener noreferrer"
            className="text-xs text-blue-600 hover:underline"
          >
            {t('aiConsent.privacyPolicy')}
          </a>
          <a
            href="https://mymanifest.app/terms"
            target="_blank"
            rel="noopener noreferrer"
            className="text-xs text-blue-600 hover:underline"
          >
            {t('aiConsent.termsOfService')}
          </a>
        </div>

        {/* Actions */}
        <div className="p-6 pt-3">
          <button
            onClick={handleConsent}
            className="w-full bg-gradient-to-r from-purple-500 to-pink-500 text-white py-3 rounded-xl font-semibold hover:from-purple-600 hover:to-pink-600 transition"
          >
            {t('aiConsent.continueButton')}
          </button>
        </div>
    </Modal>
  );
};

export default AIConsentModal;
